// // 根据环境引入不同配置 process.env.VUE_APP_ENV
// const environment = process.env.NODE_ENV || 'production'
// const config =  require('./env.' + environment)
// module.exports = config

const envConfig = require(`../config/env.${process.env.NODE_ENV}.js`);

// module.exports = {
//   ...envConfig,
// };
export default envConfig;